// extracted by mini-css-extract-plugin
module.exports = {"Inf_packDownload_form":"Inf_packDownload_form--1fY1T","list_title":"list_title--RqrIe","inf_packDownLoad":"inf_packDownLoad--2xWJn"};